module.exports = __webpack_public_path__ + "static/media/home-nft-img-1.b824ed1f.svg";